<template>
  <ApplicationLayout
    :links="sidebar"
    page="Application"
  >
      <template v-if="!getApplicationReview.reviewApplication">
        <!-- Home section -->
        <Home v-if="getSectionOpen === 0" />
        <!-- Personal info section -->
        <Personal ref="personal" v-if="getSectionOpen === 1" />
        <!-- Education section -->
        <Education v-if="getSectionOpen === 2" />
        <!-- Employment section -->
        <Employment v-if="getSectionOpen === 3" />
        <!-- Work section -->
        <Work v-if="getSectionOpen === 4" />
        <!-- Where section -->
        <Where v-if="getSectionOpen === 5" />
        <!-- Why section -->
        <Why v-if="getSectionOpen === 6" />
      </template>
      <!-- Review section -->
      <Review v-if="getApplicationReview.reviewApplication" />
  </ApplicationLayout>
</template>

<script>
import ApplicationLayout from '../../layouts/applicationLayout.vue'
import Home from '../../components/application/Home.vue'
import Education from '../../components/application/Education'
import Employment from '../../components/application/Employment'
import Personal from '../../components/application/Personal'
import Where from '../../components/application/Where'
import Why from '../../components/application/Why'
import Work from '../../components/application/Work'
import Review from '../../components/application/Review.vue'
import { mapGetters, mapActions } from 'vuex'


export default {
  components: {
    ApplicationLayout,
    Home,
    Education,
    Employment,
    Personal,
    Where,
    Why,
    Work,
    Review
    // BtnMain
  },
  computed: {
    ...mapGetters({
      getRecruit: 'authStore/getRecruit',
      getSectionOpen: 'authStore/getSectionOpen',
      getApplicationReview: 'authStore/getApplicationReview'
    })
  },
  data () {
    return {
      sidebar: [
        { linkName: 'Application Home', icon: 'house', validationName: 'appHome' },
        { linkName: 'Personal Details', icon: 'person', validationName: 'personal' },
        { linkName: 'Educational Qualifications', icon: 'pencil', validationName: 'education' },
        { linkName: 'Employment History', icon: 'inboxes', validationName: 'employment' },
        { linkName: 'Work Examples', icon: 'laptop', validationName: 'work' },
        { linkName: 'Travel Experience', icon: 'geo-alt', validationName: 'where' },
        { linkName: 'Why You', icon: 'question-circle', validationName: 'why' },
      ]
    }
  },
  async created () {
    await this.setTravelCentresAction()
    // Set recruit object from local storage
    const user = this.getRecruit
    this.setRecruitAction(user)
    this.setStatusAction('draft')

  },
  methods: {
    ...mapActions({
      setRecruitAction: 'authStore/setRecruitAction',
      setTravelCentresAction: 'authStore/setTravelCentresAction',
      updateBelfastSelectedAction: 'authStore/updateBelfastSelectedAction',
      sectionOpenAction: 'authStore/sectionOpenAction',
      setStatusAction: 'authStore/setStatusAction',
      applicationReviewAction: 'authStore/applicationReviewAction'
    })
  }
}
</script>

<style scoped>

</style>
